import './App.css';
import { useEffect } from 'react';
import { Navigate, Routes, Route, useLocation } from 'react-router-dom';

// COMPONENTS
import Nav from './components/Nav';
import Footer from './components/Footer';
import DevToggle from './components/DevToggle';
import IQButton from './components/IQButton';
import ScrollToTop from './components/ScrollToTop';

// PAGES
import Home from './pages/Home';
import Time from './pages/Time';
import About from './pages/About';
import Projects from './pages/Projects';
import ProjectItem from './pages/ProjectItem';
import Series from './pages/Series';
import SeriesItem from './pages/SeriesItem';
import Blog from './pages/Blog';
import BlogItem from './pages/BlogItem';
import Contact from './pages/Contact';
import Library from './pages/Library';
import LogoPlayer from './pages/LogoPlayer.jsx';
import SportyNerd from './pages/SportyNerd';

import Yuki from './pages/Yuki.jsx';

// COMPUTER GRAPHICS
import ComputerGraphics from './pages/ComputerGraphics';
import NintendoNav from './effects/NintendoNav'; // on shuffle nav

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

export default function App() {
  const location = useLocation();
  const focusRoutes = [ "/time" ];

  const showNav = !focusRoutes.includes(location.pathname);

  return (
      <div className = "App" style = { { display : "flex", flexDirection : "column" } }>
        { showNav && <Nav/> }
        {/* <NintendoNav side = "left"/> */}

      
        <div className = "devToggle" style = { { display : "flex", flexDirection : "column", gap : "16px" } }>
          <DevToggle/>
          {/* <IQButton/> */}
          <ScrollToTop/>
        </div>

        <Routes>
          <Route path = "/" element = { <Home/> }/>

          <Route path = "/sportynerd" element = { <SportyNerd/> }/>

          <Route path = "/time" element = { <Time/> }/>

          <Route path = "/about" element = { <About/> }/>

          <Route path = "/works" element = { <Projects/> }/>
          <Route path = "/works/:id" element = { <ProjectItem/> }/>

          {/* <Route path = "/series" element = { <Series/> }/>
          <Route path = "/series/:id" element = { <SeriesItem/> }/> */}

          <Route path = "/blog" element = { <Series/> }/>
          <Route path = "/blog/:id" element = { <BlogItem/> }/>

          <Route path = "/series/:id" element = { <SeriesItem/> }/> 

          <Route path = "/contact" element = { <Contact/> }/>

          <Route path = "/library" element = { <Library/> }/>

          <Route path = "/logoplayer" element = { <LogoPlayer/> }/>

          {/* PRETTY URLs */}
          <Route path = "/graphics" element = { <ComputerGraphics/> }/>
          <Route path="/graphics/hw1" element={<Navigate to="/blog/271afaf7-b684-800a-b9c7-e46e7333cccb" replace />} />
          <Route path="/graphics/hw2" element={<Navigate to="/blog/278afaf7-b684-806f-8d5a-e77c5c95fd03" replace />} />
          <Route path="/graphics/hw3" element={<Navigate to="/blog/283afaf7-b684-80a1-9036-da7bc570bda3" replace />} />
          <Route path="/graphics/hw4" element={<Navigate to="/blog/2a1afaf7-b684-8008-aa88-cb3d7ba837ed" replace />} />
          <Route path="/graphics/hw5" element={<Navigate to="/blog/2a3afaf7-b684-80b0-888a-e70d1aea401d" replace />} />

          <Route path="/graphics/hw9" element={<Navigate to="/blog/2a9afaf7-b684-80fa-8a6c-e34989293aa7" replace />} />
          <Route path="/graphics/hw10" element={<Navigate to="/blog/2b0afaf7-b684-8023-9ad2-e19758bac5a6" replace />} />

          <Route path="/series/light" element={<Navigate to="/series/2f4afaf7-b684-80dd-b86b-fcee0f707063" replace />} />
          
          <Route path = "/yuki" element = { <Yuki/> }/>

          <Route path = "/resume" element = { <ExternalRedirect to = "https://drive.google.com/file/d/1g5iJY07Mgyh7G7cdeAjYhEP0oWStnY5A/view"/> }/>
        </Routes>
        
        { showNav && <Footer/> }

      </div>
  );
}